import { qdtComponents } from "../config/globalApp";
import { SelectionOptionsType } from "../pages/Leaderboard";

export const fetchFieldValues = async (
  fieldName: string
): Promise<SelectionOptionsType[]> => {
  const qApp = await qdtComponents.qAppPromise;

  const qSessionObject = await qApp?.createGenericObject({
    qInfo: { qType: "fieldValueFetcher" },
    qHyperCubeDef: {
      qDimensions: [
        {
          qDef: { qFieldDefs: [fieldName] },
          qNullSuppression: true,
        },
      ],
      qInitialDataFetch: [
        {
          qTop: 0,
          qLeft: 0,
          qHeight: 2000,
          qWidth: 1,
        },
      ],
    },
  });

  const layout = await qSessionObject.getLayout();
  const totalRows = layout.qHyperCube.qSize.qcy;
  const batchSize = 2000;
  const results: { label: string; value: string }[] = [];

  for (let qTop = 0; qTop < totalRows; qTop += batchSize) {
    const dataPages = await qSessionObject.getHyperCubeData("/qHyperCubeDef", [
      { qTop, qLeft: 0, qHeight: batchSize, qWidth: 1 },
    ]);

    const rows = dataPages[0]?.qMatrix || [];
    rows.forEach((row: any) => {
      const text = row[0]?.qText;
      if (text) {
        results.push({ label: text, value: text });
      }
    });
  }

  results.sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
  );

  return results;
};
